// ----------------------------------------------------------------------
// The token an invitation link carries, taken out of the address bar at once.
//
// The link is `/login/invite#t=<token>`. The fragment is never sent to a
// server or in a `Referer`, but it is in `location.href`, and PostHog tags
// every event with `$current_url` and Sentry records navigations. Both start
// after the first paint, so this runs before either: at the top of `index`,
// it moves the token into this tab's storage and puts the address back
// without it. The page reads the token from here, and a reload still works.
// ----------------------------------------------------------------------

const KEY = 'beast.invitation.token'

export const INVITATION_PATH = '/login/invite'

/** Moves a link's token from the address bar into this tab. Runs at boot. */
export const invitationLinkTokenCapture = (
  location: Pick<Location, 'pathname' | 'search' | 'hash'> = window.location,
  history: Pick<History, 'replaceState' | 'state'> = window.history,
  storage: Storage = sessionStorage,
): void => {
  if (location.pathname !== INVITATION_PATH) {
    return
  }

  const token = /(?:^#|&)t=([A-Za-z0-9_-]+)/.exec(location.hash)?.[1]
  if (!token) {
    return
  }

  storage.setItem(KEY, token)
  history.replaceState(
    history.state,
    '',
    `${location.pathname}${location.search}`,
  )
}

export const invitationLinkTokenRead = (
  storage: Storage = sessionStorage,
): string | null => storage.getItem(KEY)

/** Once the invitation has been dealt with, so the next sign-in is plain. */
export const invitationLinkTokenForget = (
  storage: Storage = sessionStorage,
): void => {
  storage.removeItem(KEY)
}
